import ENDPOINT from 'constants/endPoint';
import axiosClient from 'utils/axios';

export default {
  async getRoomImages({ placeId }) {
    const path = ENDPOINT.ROOM_IMAGES(placeId);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async addImageToRoom({ placeId, roomId, images, video }) {
    const path = ENDPOINT.ADD_IMAGES_TO_ROOMS(placeId);
    const payload = {
      roomIds: [roomId],
    };

    if (images?.length) {
      payload.images = images;
    }

    if (video?.length) {
      payload.video = video;
    }

    const response = await axiosClient.post(path, payload);

    return response.data;
  },

  async deleteRoomImages({ placeId, roomIds, images }) {
    const path = `${ENDPOINT.ROOM_IMAGES(placeId)}/images`;

    await axiosClient.delete(path, {
      data: { roomIds, images },
    });
  },

  async changePositionRoomImages({ placeId, roomId, images }) {
    const path = ENDPOINT.CHANGE_POSITION_ROOM_IMAGES(placeId, roomId);

    const response = await axiosClient.put(path, { images });

    return response.data;
  },

  async getRoomsOfPlace({ placeId }) {
    const path = ENDPOINT.ROOMS_OF_PLACE(placeId);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getRoomDetailOfPlace({ placeId, roomId }) {
    const path = ENDPOINT.ROOM_DETAIL_OF_PLACE(placeId, roomId);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async createNewRoom(payload) {
    const path = ENDPOINT.CREATE_NEW_ROOM(payload.placeId);

    await axiosClient.post(path, payload);
  },

  async updateRoomOfPlace({ result }) {
    const { placeId, roomId } = result;

    const path = ENDPOINT.ROOM_DETAIL_OF_PLACE(placeId, roomId);

    await axiosClient.put(path, result);
  },

  async deleteRoomOfPlace({ placeId, roomId }) {
    const path = `${ENDPOINT.ROOM_DETAIL_OF_PLACE(placeId, roomId)}`;

    await axiosClient.delete(path);
  },

  async getRoomNamesSetting() {
    const limit = 'roomNames';
    const path = ENDPOINT.LIMIT_SETTING(limit);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getBedTypesSetting() {
    const limit = 'bedTypes';
    const path = ENDPOINT.LIMIT_SETTING(limit);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async setRoomPreviewImage({ placeId, thisRoomId, image }) {
    const path = ENDPOINT.ROOM_PREVIEW_IMAGE(placeId, thisRoomId);

    const response = await axiosClient.put(path, { previewImage: image });

    return response.data;
  },

  async updateRoomVideo({ placeId, roomId, video }) {
    const path = ENDPOINT.ROOM_VIDEO(placeId, roomId);

    const response = await axiosClient.put(path, { video });

    return response.data;
  },

  async deleteRoomVideo({ placeId, roomId }) {
    const path = ENDPOINT.ROOM_VIDEO(placeId, roomId);

    const response = await axiosClient.delete(path);

    return response.data;
  },
};
